import {RouteContainer, RouteType as BoilerRouteType } from 'b302-frontend-library';
import Dashboard from '../../components/admin/pages/Dashboard';
import Universities from '../../components/admin/pages/Universities/Universities';
import UniversityDetail from '../../components/admin/pages/Universities/UniversityDetail';
import Responses from '../../components/admin/pages/Responses/Responses';
import ResponseDetail from '../../components/admin/pages/Responses/ResponseDetail/ResponseDetail';
import Countries from '../../components/admin/pages/Countries/Countries';
import SubjectAreas from '../../components/admin/pages/SubjectAreas/SubjectAreas';
import Whitelist from '../../components/admin/pages/Whitelist/Whitelist';
import NewUniversity from '../../components/admin/pages/Universities/NewUniversity';

const routeContainer = new RouteContainer();

routeContainer.group('/admin', () => {
    routeContainer.add('/', Dashboard, 'admin-dashboard');
    routeContainer.add('/universities', Universities, 'admin-universities');
    routeContainer.add('/universities/new', NewUniversity, 'admin-new-university');
    routeContainer.add('/universities/:id', UniversityDetail, 'admin-edit-university');
    routeContainer.add('/universities/:id/responses', Responses, 'admin-responses');
    routeContainer.add('/universities/:id/responses/:responseId', ResponseDetail, 'admin-response-detail');

    routeContainer.add('/countries', Countries, 'admin-countries');
    routeContainer.add('/subject-areas', SubjectAreas, 'admin-subject-areas');
    routeContainer.add('/whitelist', Whitelist, 'admin-whitelist');
}, BoilerRouteType.PRIVATE);

export default routeContainer.getRoutes();
